"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.collectDeviceMetrics = collectDeviceMetrics;
function collectDeviceMetrics(provider) {
  if (!provider) return null;
  return provider.collectAll();
}